import { RefObject } from 'react';
import { OnNext } from '../types';
import { Interstitial } from './components/interstitial/interstitial';
import { Question } from './components/question/question';
import { SurveyItemProps } from './types';

interface ExtendedSurveyItemProps extends SurveyItemProps {
  onWhyWeAskExpand?: () => void;
  hideWhyWeAsk?: boolean;
  isLoading?: boolean;
  onNext: OnNext;
  onBack?: () => void;
  isBackDisabled?: boolean;
  questionTitleRef?: RefObject<HTMLDivElement>;
  onSkip?: () => void;
}

export const SurveyItem = ({ surveyItem, onNext, onBack, isBackDisabled, onWhyWeAskExpand, hideWhyWeAsk, isLoading, questionTitleRef, onSkip }: ExtendedSurveyItemProps) => {
  switch (surveyItem.questionnaireItemKind) {
    case 'question':
      return <Question question={surveyItem} isLoading={isLoading} onWhyWeAskExpand={onWhyWeAskExpand} hideWhyWeAsk={hideWhyWeAsk} questionTitleRef={questionTitleRef} onNext={onNext} onSkip={onSkip} />;
    case 'interstitial': {
      return <Interstitial interstitial={surveyItem} onNext={onNext} onBack={onBack} isBackDisabled={isBackDisabled} />;
    }
    default:
      return <div>Survey item type not implemented</div>;
  }
};
